import "./skills.css"
import { SiPostman, SiJavascript, SiMongodb, SiExpress, SiHtml5, SiCss3 } from 'react-icons/si';
import { FaNpm, FaReact, FaNodeJs, FaDatabase } from "react-icons/fa";
import {BsGithub} from "react-icons/bs";
import {GiBrain} from "react-icons/gi"
import { AiOutlineTeam } from "react-icons/ai";


export const Skills = () => {
    return (

        <div className="aboutContainer" id="skills">

            <div className="headingBtn">
                <p className="heading">Skills</p>
                <div></div>
            </div>

            <div className="skillIcon_maindiv">
                <div className="skillIcon_div2">
                    <div data-aos="flip-right" ><SiHtml5 className="skill_icon" /> <p>HTML</p></div>
                    <div data-aos="flip-right" ><SiCss3 className="skill_icon" /> <p>CSS</p></div>
                    <div data-aos="flip-right" ><SiJavascript className="skill_icon" /> <p>JavaScript</p></div>
                    <div data-aos="flip-right" ><FaReact className="skill_icon" /> <p>React</p></div>


                </div>
                <div className="skillIcon_div1">
                    <div data-aos="flip-down" ><FaNodeJs className="skill_icon" /> <p>Nodejs</p></div>
                    <div data-aos="flip-down" ><SiExpress className="skill_icon" /> <p>Express</p></div>
                    <div data-aos="flip-down" ><SiMongodb className="skill_icon" /> <p>MongoDB</p></div>
                    <div data-aos="flip-down" ><FaDatabase className="skill_icon" /> <p>DS & Algo</p></div>
                    <div data-aos="flip-down" ><AiOutlineTeam className="skill_icon" /> <p>Soft Skills</p></div>
                </div>
                <div className="skillIcon_div2">
                    <div data-aos="flip-right" ><SiPostman className="skill_icon" /> <p>Postman</p></div>
                    <div data-aos="flip-right" ><BsGithub className="skill_icon" /> <p>Github</p></div>
                    <div data-aos="flip-right" ><FaNpm className="skill_icon" /> <p>NPM</p></div>
                    <div data-aos="flip-right" ><GiBrain className="skill_icon" /> <p>Creative</p></div>
                </div>




            </div>



        </div>
    )
}